import Logger from '../services/logger.service'

export function normalizeCity(cityName: string): string {
  try {
    let output = cityName?.trim().toUpperCase() || ''

    // Replace abbreviations with full forms
    output = output.replace(/(.+?)?(TOWNSHIP OF)(.*)?/i, '$1$3 TOWNSHIP')
    output = output.replace(/(.+?)?(BOROUGH OF)(.*)?/i, '$1$3 BOROUGH')

    output = output.replace(/TOWN OF/i, '')
    output = output.replace(/CITY OF/i, '')

    output = output.replace(/(^|\s)ST(\.|\s)/i, 'SAINT')
    output = output.replace(/(^|\s)STE(\.|\s)/i, 'SAINTE')

    output = output.replace(/(^|\s)MT(\.|\s)/i, 'MOUNT')
    output = output.replace(/(^|\s)FT(\.|\s)/i, 'FORT')

    output = output.replace(/(^|\s)E(\.|\s)/i, 'EAST')
    output = output.replace(/(^|\s)W(\.|\s)/i, 'WEST')
    output = output.replace(/(^|\s)N(\.|\s)/i, 'NORTH')
    output = output.replace(/(^|\s)S(\.|\s)/i, 'SOUTH')

    output = output.replace(/(^|\s)N$/i, 'NORTH')
    output = output.replace(/(^|\s)S$/i, 'SOUTH')
    output = output.replace(/(^|\s)E$/i, 'EAST')
    output = output.replace(/(^|\s)W$/i, 'WEST')

    output = output.replace(/(^|\s)NW$/i, 'NORTHWEST')
    output = output.replace(/(^|\s)NE$/i, 'NORTHEAST')
    output = output.replace(/(^|\s)SW$/i, 'SOUTHWEST')
    output = output.replace(/(^|\s)SE$/i, 'SOUTHEAST')

    output = output.replace(/(^|\s)TWP(\.|$)/i, 'TOWNSHIP')

    output = output.replace(/(^|\s)NW\./i, 'NORTHWEST')
    output = output.replace(/(^|\s)NE\./i, 'NORTHEAST')
    output = output.replace(/(^|\s)SW\./i, 'SOUTHWEST')
    output = output.replace(/(^|\s)SE\./i, 'SOUTHEAST')

    output = output.replace(/(^|\s)N\.W\.$/i, 'NORTHWEST')
    output = output.replace(/(^|\s)N\.E\.$/i, 'NORTHEAST')
    output = output.replace(/(^|\s)S\.W\.$/i, 'SOUTHWEST')
    output = output.replace(/(^|\s)S\.E\.$/i, 'SOUTHEAST')

    // Remove text inside parentheses
    output = output.replace(/\([^()]*\)/g, '')

    // Remove non-alphanumeric characters
    output = output.replace(/[^A-Za-z0-9]/g, '')

    // Remove extra whitespace
    output = output.replace(/\s/g, '')

    return output.trim().toLocaleLowerCase()
  } catch (error) {
    Logger.error(`Error normalizeCity: ${error instanceof Error ? error.message : 'UNKNOWN ERROR'}`)
    return ''
  }
}
